import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../../Context';
import { useContext, useEffect, useState } from 'react';
import { Popover, Transition } from '@headlessui/react';
import {
    ChevronDownIcon,
    WrenchScrewdriverIcon,
    ExclamationTriangleIcon,
    DocumentTextIcon,
    Bars3Icon,
    XMarkIcon
} from '@heroicons/react/24/outline';

const nav = [
    {
        name: 'Painel',
        href: '/tecnicoIndex',
        current: false,
        icon: WrenchScrewdriverIcon,
        description: 'Painel principal técnico'
    },
    {
        name: 'Logs',
        href: '/tecnicoIndex/logs',
        current: false,
        icon: ExclamationTriangleIcon,
        description: 'Sistema de logs e erros'
    },
    {
        name: 'Requests',
        href: '/tecnicoIndex/requests',
        current: false,
        icon: DocumentTextIcon,
        description: 'Gerenciamento de solicitações'
    }
]

const Navbar = () => {
    const { states } = useContext(AuthContext);
    const [navigationFerias, setNavigationFerias] = useState(nav);

    const currentItemSecondary = () => {
        const updatedNavigationFerias = navigationFerias.map((item) => {
            if (item.href === window.location.pathname) {
                return { ...item, current: true };
            } else {
                return { ...item, current: false };
            }
        });

        setNavigationFerias(updatedNavigationFerias);
    };

    useEffect(() => {
        currentItemSecondary();
    }, []);

    return (
        <>
            {/* Desktop Navigation */}
            <div className="hidden lg:block mb-6">
                <div className="relative bg-gradient-to-br from-indigo-50/80 via-white/80 to-blue-50/80 backdrop-blur-sm rounded-2xl shadow-lg border border-brand-cyan/20/50 overflow-hidden">
                    <div className="absolute inset-0 bg-gradient-to-br from-indigo-500/5 to-blue-500/5"></div>

                    <div className="relative px-6 py-3">
                        <div className="flex items-center justify-between">
                            {/* Logo da Área Técnica */}
                            <div className="flex items-center space-x-3">
                                <div className="p-2 rounded-lg bg-brand-cyan/20">
                                    <WrenchScrewdriverIcon className="w-5 h-5 text-brand-cyan-dark" />
                                </div>
                                <h2 className="text-lg font-bold bg-gradient-to-r from-gray-900 via-indigo-800 to-blue-800 bg-clip-text text-transparent">
                                    Área Técnica
                                </h2>
                            </div>

                            {/* Menu de Navegação */}
                            <div className="flex items-center space-x-2">
                                {navigationFerias?.map((item, index) => {
                                    const IconComponent = item.icon;
                                    return (
                                        <Link
                                            key={index}
                                            to={item.href}
                                            onClick={currentItemSecondary}
                                            className={`group relative flex items-center px-4 py-2 rounded-xl transition-all duration-300 ${item.current
                                                ? "bg-gradient-to-r from-indigo-500 via-blue-600 to-indigo-700 text-white shadow-lg"
                                                : "bg-white/80 text-gray-700 hover:bg-brand-cyan/10 hover:text-brand-cyan-dark border border-brand-cyan/20"
                                                }`}
                                        >
                                            <div className="flex items-center space-x-2">
                                                <IconComponent className={`w-4 h-4 ${item.current
                                                    ? "text-white"
                                                    : "text-brand-cyan-dark group-hover:text-brand-cyan-dark"
                                                    }`} />
                                                <span className="font-semibold text-sm">
                                                    {item.name}
                                                </span>
                                            </div>

                                            {item.current && (
                                                <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/10 to-blue-500/10 rounded-xl"></div>
                                            )}
                                        </Link>
                                    );
                                })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Mobile Navigation */}
            <div className="lg:hidden mb-4">
                <Popover className="relative">
                    <Popover.Button className="w-full group relative inline-flex items-center justify-between px-4 py-3 border border-transparent rounded-2xl shadow-lg text-sm font-semibold text-white bg-gradient-to-r from-indigo-600 via-blue-700 to-indigo-700 hover:from-indigo-700 hover:via-blue-800 hover:to-indigo-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-all duration-300">
                        <div className="flex items-center space-x-3">
                            <div className="p-1.5 rounded-lg bg-white/20">
                                <WrenchScrewdriverIcon className="w-4 h-4" />
                            </div>
                            <span>Área Técnica</span>
                        </div>
                        <ChevronDownIcon className="h-4 w-4 group-hover:scale-110 transition-transform duration-200" />
                    </Popover.Button>

                    <Transition
                        as={Fragment}
                        enter="transition ease-out duration-200"
                        enterFrom="opacity-0 translate-y-1"
                        enterTo="opacity-100 translate-y-0"
                        leave="transition ease-in duration-150"
                        leaveFrom="opacity-100 translate-y-0"
                        leaveTo="opacity-0 translate-y-1"
                    >
                        <Popover.Panel className="absolute z-50 mt-2 w-full">
                            <div className="relative bg-white rounded-2xl shadow-xl border border-gray-200 overflow-hidden">
                                <div className="relative p-3">
                                    <div className="space-y-1">
                                        {navigationFerias?.map((item) => {
                                            const IconComponent = item.icon;
                                            return (
                                                <Link
                                                    key={item.name}
                                                    to={item.href}
                                                    onClick={currentItemSecondary}
                                                    className={`group relative flex items-center p-3 rounded-xl transition-all duration-300 ${item.current
                                                        ? "bg-gradient-to-r from-indigo-500 to-blue-600 text-white shadow-lg"
                                                        : "bg-white text-gray-700 hover:bg-brand-cyan/10 hover:text-brand-cyan-dark border border-gray-100"
                                                        }`}
                                                >
                                                    <div className="flex items-center space-x-3">
                                                        <IconComponent className={`w-4 h-4 ${item.current
                                                            ? "text-white"
                                                            : "text-brand-cyan-dark group-hover:text-brand-cyan-dark"
                                                            }`} />
                                                        <span className="font-semibold text-sm">
                                                            {item.name}
                                                        </span>
                                                    </div>

                                                    {item.current && (
                                                        <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/10 to-blue-500/10 rounded-xl"></div>
                                                    )}
                                                </Link>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </Popover.Panel>
                    </Transition>
                </Popover>
            </div>
        </>
    );
};

export default Navbar;

